import Vue from 'vue'
import App from './App.vue'
import { store } from './store/store.js'
// import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import Vuelidate from 'vuelidate'

Vue.config.productionTip = false

Vue.use(Vuelidate)
firebase.initializeApp({
  // apiKey: "AIzaSyC0X5QCT-ZfNceGD1vir7nCrc5Y_MySq-E",
  // authDomain: "dgl-blade-competition.firebaseapp.com",
  // databaseURL: "https://dgl-blade-competition.firebaseio.com",
  // projectId: "dgl-blade-competition",
  // storageBucket: "dgl-blade-competition.appspot.com",
  // messagingSenderId: "658282880825",
  apiKey: 'AIzaSyDxctvQIRKshrSsGUb6Pckbok2mf3CU_nQ',
  authDomain: 'osp-quizz.firebaseapp.com',
  databaseURL: 'https://osp-quizz.firebaseio.com',
  projectId: 'osp-quizz',
  storageBucket: 'osp-quizz.appspot.com',
  messagingSenderId: '128358121347'
})

export const fbase = firebase
// export const db = firebase.firestore();

new Vue({
  el: '#osp-quizz-wrapper',
  store: store,
  render: function (h) {
    return h(App)
  }
})
